export const CONDITION_POSITION_CALCULATOR = 1;
export const SLOT_TYPE_POSITION_CALCULATOR = 2;

import slotTypePositionCalculator from './positionCalculators/SlotTypePositionCalculator';
import conditionPositionCalculator from './positionCalculators/ConditionPositionCalculator';

export default function positionCalculatorProvider(positionCalculatorType) {
    switch (positionCalculatorType) {
        case SLOT_TYPE_POSITION_CALCULATOR:
            return slotTypePositionCalculator;

        case CONDITION_POSITION_CALCULATOR:
            return conditionPositionCalculator;
    }

    console.warn('Cannot find position calculator', positionCalculatorType);//eslint-disable-line no-console
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/slot-arrangement-policies/PositionCalculatorProvider.js